/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateAddonDto = {
    /**
     * Add-on name (unique, max 100 chars)
     */
    name?: string;
    /**
     * Add-on price
     */
    price?: number;
    /**
     * Duration in days
     */
    durationDays?: number;
    /**
     * Add-on description
     */
    description?: string;
    /**
     * Add-on type
     */
    addonType?: UpdateAddonDto.addonType;
    /**
     * Activate or deactivate the add-on
     */
    isActive?: boolean;
};
export namespace UpdateAddonDto {
    /**
     * Add-on type
     */
    export enum addonType {
        IN_APP = 'in_app',
        OFFLINE_MARKETING = 'offline_marketing',
    }
}

